// ============================================================
// Magic Turtle Words — Game Constants
// ============================================================

export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;

// Physics
export const GRAVITY = 1800;          // px/s²
export const MAX_FALL_SPEED = 900;    // px/s
export const JUMP_FORCE = -620;       // px/s
export const PLAYER_SPEED = 240;      // px/s
export const FRICTION_GROUND = 0.80;  // velocity multiplier per frame on ground
export const FRICTION_AIR = 0.98;     // velocity multiplier per frame in air

// Tank character
export const TANK_CANVAS_W = 320;
export const TANK_CANVAS_H = 460;
export const TANK_HITBOX_W = 80;
export const TANK_HITBOX_H = 110;

// Word system
export const MAX_SPAWNED_OBJECTS = 12;
export const WORD_COOLDOWN = 500;    // ms between spawns

// Camera
export const CAMERA_LERP = 0.08;
export const CAMERA_DEAD_ZONE_X = 160;
export const CAMERA_DEAD_ZONE_Y = 120;

// UI
export const WORD_INPUT_WIDTH = 380;

// Colors (hex)
export const COLOR = {
  sky:         0x87CEEB,
  skyDeep:     0x1a6b8a,
  ocean:       0x006994,
  oceanLight:  0x4FC3F7,
  sand:        0xF5DEB3,
  coral:       0xFF6B6B,
  stone:       0x7F8C8D,
  wood:        0x8B4513,
  grass:       0x27AE60,
  lava:        0xFF4500,
  ice:         0xADD8E6,
  gold:        0xFFD700,
  white:       0xFFFFFF,
  black:       0x000000,
  turtleGreen: 0x2E8B57,
  shellBrown:  0x8B6914,
  textDark:    0x1A1A2E,
  hud:         0x16213E,
};

// Z-layers
export const Z = {
  background:  0,
  platforms:   10,
  hazards:     15,
  spawned:     20,
  player:      30,
  particles:   40,
  ui:          100,
};

// Level state
export const STATE = {
  MENU:          'menu',
  LEVEL_SELECT:  'levelSelect',
  LOADING:       'loading',
  PLAYING:       'playing',
  PAUSED:        'paused',
  LEVEL_COMPLETE:'levelComplete',
  GAME_OVER:     'gameOver',
};
